// pages/LeadInspectorPage.jsx
//
// Staff Lead Inspector. Two screens on two backend endpoints (leads/
// inspector_api.py in the backend):
//   - /lead-inspector       the list: recent leads in a range, or an exact
//                           search by lead id, email or phone (all dates).
//   - /lead-inspector/:id   one lead: timeline, buyer responses, fields,
//                           tracking, outbound, event log. A shareable link.
// The pieces live in components/lead-inspector/ (model.js holds the labels,
// params and formatters). AuctionValidator.jsx still reads the older
// /leads/{id}/timeline endpoint and is not part of this screen.
import React from 'react'
import { useParams } from 'react-router-dom'
import InspectorList from '../components/lead-inspector/InspectorList'
import InspectorDetail from '../components/lead-inspector/InspectorDetail'
import { LEAD_INSPECTOR_RESPONSIVE_CSS } from '../components/lead-inspector/model'

export default function LeadInspectorPage() {
  const { leadId } = useParams()
  return (
    <>
      <style>{LEAD_INSPECTOR_RESPONSIVE_CSS}</style>
      {leadId ? <InspectorDetail key={leadId} leadId={leadId} /> : <InspectorList />}
    </>
  )
}
